{
  "ts": 1749107951,
  "tsCommit": 1749107916,
  "repoName": "WebSignup",
  "branchName": "prod",
  "rev": "6e03674",
  "ver": "20250605_0719_WebSignup_prod_6e03674",
  "env": "production",
  "isBranchDeployment": false
}
